module.exports = __webpack_public_path__ + "img/wallpaper-2.a73369b1.jpg";